import { action } from 'satcheljs';

/**
 * Action to mutate showDialogMessageFlag to render PeoplePickerDialog
 * @param showDialogMessageFlag - whether to show or hide PeoplePicker dialog
 */
const showSharedFolderPeoplePickerDialog = action(
    'showAddSharedFolderDialog',
    (showDialogMessageFlag: boolean) => ({
        showDialogMessageFlag,
    })
);
export default showSharedFolderPeoplePickerDialog;
